import { Navigate } from "react-router-dom";
import { useContext } from "react";
import UserContext from "./UserContext";

export default function PrivateRoute({children}) {
    //const token = useSelector(getToken);
    const user = useContext(UserContext);

    if (user.login) {
        return children;
    } else {
        return <Navigate to="/login" replace />        
    }
}